import React from 'react';
import { Row, OuterIndent } from '../../../Layouts';
import { MemberRowHeaderItem } from './style';

export const MemberRowHeader = () => {
    return (
        <OuterIndent indent={'16px 0'}>
            <Row>
                <MemberRowHeaderItem width={'15%'}>Members</MemberRowHeaderItem>
                <MemberRowHeaderItem width={'35%'}>Status</MemberRowHeaderItem>
                <MemberRowHeaderItem width={'15%'}>Membership type</MemberRowHeaderItem>
                <MemberRowHeaderItem width={'7%'}>Credits</MemberRowHeaderItem>
                <MemberRowHeaderItem width={'13%'}>Paid until</MemberRowHeaderItem>
                <MemberRowHeaderItem width={'10%'}>Date joined</MemberRowHeaderItem>
                <MemberRowHeaderItem width={'5%'} />
            </Row>
        </OuterIndent>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/MemberRow/Header.js